module.exports = __webpack_public_path__ + "img/Logo-Era-Tua.e6ac0c9.svg";